import { useEffect, useState } from 'react';
import useCauzeStore from 'stores/CauzeStoreV2';

const useCreateCauze = ({ userContext, eventId }) => {
  const [cauzeLoaded, setCauzeLoaded] = useState(false);
  const cauzeStore = useCauzeStore();

  useEffect(() => {
    cauzeStore.onCreateUnmount();
    if (eventId) {
      cauzeStore
        .loadCauzeToEdit({ userContext, eventId })
        .finally(() => setCauzeLoaded(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  return { cauzeLoaded };
};

export default useCreateCauze;
